import { CheckCircle } from "lucide-react";

interface WhatYouWillLearnSectionProps {
  items: string[];
}

export const WhatYouWillLearnSection = ({ items }: WhatYouWillLearnSectionProps) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="border-t pt-12 mt-12">
      <h2 className="text-3xl font-bold mb-6">What You'll Learn</h2>
      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={index} className="flex items-start gap-3">
            <CheckCircle className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" />
            <p className="text-lg text-muted-foreground">{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
